module.exports = __webpack_public_path__ + "img/logoXSKTDT.2143742b.png";